// Créer ce nouveau fichier

export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      console.error("Error parsing user data:", e);
      return null;
    }
  }
  return null;
};

export const getUserId = () => {
  const user = getUser();
  return user ? user.id : 'guest';
};

// Fonction de logout pour nettoyer les données de l'utilisateur
export const logout = () => {
  // Récupérer l'ID utilisateur actuel avant de le supprimer
  const user = getUser();
  const userId = user ? user.id : 'guest';
  
  // Supprimer les données spécifiques à cet utilisateur
  localStorage.removeItem(`smartFarmWizardData_${userId}`);
  
  // Supprimer les autres données d'authentification
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  
  // Rediriger vers la page de login
  window.location.href = '/login';
};

// Fonction pour nettoyer les données d'autres utilisateurs
export const cleanOtherUsersData = () => {
  const currentUserId = getUserId();
  
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('smartFarmWizardData_') && !key.includes(currentUserId)) {
      console.log(`Removing data for other user: ${key}`);
      localStorage.removeItem(key);
    }
  });
};